// @flow
import * as React from 'react';
import InterestFollowButton from 'app/common/react/components/Categories/InterestFollowButton';
import NavigateLink from 'app/common/react/ui/NavigateLink';
import PrettyNumber from 'app/common/react/i18n/PrettyNumber';
import PropTypes from 'prop-types';
import Topic from 'app/common/react/components/common/TopicRep/Topic';
import { Box, Card } from 'gestalt';

type PropType = {
  backgroundColor?: string,
  followedByMe: boolean,
  followersCount?: number,
  id: string,
  image: ?{
    url: string,
    height: number,
    width: number,
  },
  name: string,
  url?: string,
  width?: number,
  followingButton?: React.Node,
};

const TOPIC_REP_WIDTH = 236; // TODO(yenwei) - this should ideally go away once we move towards a more responsive design

export default function TopicRep(props: PropType) {
  const {
    backgroundColor,
    followedByMe,
    followersCount,
    id,
    image,
    name,
    url,
    width = TOPIC_REP_WIDTH,
    followingButton,
  } = props;

  const formattedCount = followersCount ? (
    <PrettyNumber value={followersCount} shortform shortformMaximumFractionDigits={1} />
  ) : (
    ''
  );

  const followButton = followingButton || (
    <InterestFollowButton fullWidth topicId={id} isFollowed={followedByMe} />
  );

  return (
    <Card>
      <Box width={width}>
        {url ? (
          <NavigateLink to={`/topics/${url}/`}>
            <Topic
              backgroundColor={backgroundColor}
              followersCount={followersCount}
              followersCountDisplay={formattedCount}
              image={image}
              name={name}
              width={width}
            />
          </NavigateLink>
        ) : (
          <Topic
            backgroundColor={backgroundColor}
            followersCount={followersCount}
            followersCountDisplay={formattedCount}
            image={image}
            name={name}
            width={width}
          />
        )}
        <Box column={12} marginTop={2}>
          {followButton}
        </Box>
      </Box>
    </Card>
  );
}

TopicRep.propTypes = {
  backgroundColor: PropTypes.string,
  followedByMe: PropTypes.bool.isRequired,
  followersCount: PropTypes.number,
  id: PropTypes.string.isRequired,
  image: PropTypes.shape({
    url: PropTypes.string.isRequired,
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
  }),
  name: PropTypes.string.isRequired,
  url: PropTypes.string,
};
